import { useState } from "react";
import NewSearchPanel from "./NewSearchPanel";
import SourcingBatches from "./SourcingBatches";
import RipeningPanel from "./RipeningPanel";

const fmt = (n) => (n == null ? "—" : Number(n).toLocaleString("en-US"));

export default function SourceView() {
  const [refresh, setRefresh] = useState(0);
  const [stats, setStats] = useState(null);
  // Source flow D: the panel's current stage + new batch id dim/highlight the list
  const [search, setSearch] = useState({ stage: 'configure', batchId: null });
  const [openRequest, setOpenRequest] = useState(null);
  const [rankStatus, setRankStatus] = useState(null);
  const token = localStorage.getItem('expertnet_token');

  return (
    // SOURCE-SHEET-1: the page header (h1 + stepper) is rendered by NewSearchPanel,
    // so the stage copy and step state come from the one component that owns them.
    <div style={{ padding: 24, maxWidth: 1200, display: 'flex', flexDirection: 'column', gap: 18 }}>
      <NewSearchPanel
        token={token}
        onIngested={() => setRefresh(k => k + 1)}
        onStageChange={(stage, batchId) => setSearch({ stage, batchId })}
        onOpenBatch={(id, opts) => setOpenRequest(r => ({ id, n: (r?.n || 0) + 1, rank: !!opts?.rank }))}
        rankStatus={rankStatus}
      />
      {stats && (
        <div style={{
          display: 'flex', justifyContent: 'flex-end', gap: 6, marginBottom: -8,
          fontFamily: 'var(--font-data)', fontSize: 11, color: 'var(--text-4)',
        }}>
          <span><span style={{ color: 'var(--text-2)' }}>{fmt(stats.batches)}</span> batches</span>
          <span>·</span>
          <span><span style={{ color: 'var(--text-2)' }}>{fmt(stats.leads)}</span> leads</span>
          <span>·</span>
          <span><span style={{ color: 'var(--accent)' }}>{fmt(stats.known)}</span> known</span>
        </div>
      )}
      <SourcingBatches
        project={null}
        token={token}
        refreshKey={refresh}
        onStats={setStats}
        dimmed={search.stage !== 'configure'}
        highlightId={search.stage === 'done' ? search.batchId : null}
        openRequest={openRequest}
        onRankStatus={setRankStatus}
      />
      <RipeningPanel token={token} />
    </div>
  );
}
